import React from 'react'
import { usePersonPageParams } from './personPageRouteUtil'
import AboutTabSkeleton from './tabs/AboutTabSkeleton'
import DetailsTabSkeleton from './tabs/DetailsTabSkeleton'
import MemoriesTabSkeleton from './tabs/MemoriesTabSkeleton'
import OrdinancesTabSkeleton from './tabs/OrdinancesTabSkeleton'
import SourceCentricDetailsTabSkeleton from './tabs/SourceCentricDetailsTabSkeleton'
import VitalsCardSkeleton from './cards/vitals-card/VitalsCardSkeleton'
import FamilyMembersCardSkeleton from './cards/family-members-card/FamilyMembersCardSkeleton'
import SourcesCardSkeleton from './cards/sources-card/SourcesCardSkeleton'
import ToolsCardSkeleton from './cards/tools-card/ToolsCardSkeleton'
import SearchRecordsCardSkeleton from './cards/search-records-card/SearchRecordsCardSkeleton'
import CollaborateTabSkeleton from './tabs/CollaborateTabSkeleton'
import TimelineTabSkeleton from './tabs/TimelineTabSkeleton'
import NonVitalsTabSkeleton from './tabs/NonVitalsTabSkeleton'
import useSourceCentricDetailsFlag from '../data-service/useSourceCentricDetailsFlag'

const subPageContentMap = {
  about: AboutTabSkeleton,
  details: DetailsTabSkeleton,
  memories: MemoriesTabSkeleton,
  ordinances: OrdinancesTabSkeleton,
  vitals: VitalsCardSkeleton,
  'non-vitals': NonVitalsTabSkeleton,
  family: FamilyMembersCardSkeleton,
  sources: SourcesCardSkeleton,
  tools: ToolsCardSkeleton,
  'search-records': SearchRecordsCardSkeleton,
  collaborate: CollaborateTabSkeleton,
  timeline: TimelineTabSkeleton,
}

export default function PersonPageContentSkeleton(): JSX.Element {
  const { subPage } = usePersonPageParams('partial')
  const { data: sourceCentricDetailsFlag } = useSourceCentricDetailsFlag()

  if (subPage === 'details' && sourceCentricDetailsFlag?.isOn) {
    return <SourceCentricDetailsTabSkeleton />
  }

  const Content = subPage ? subPageContentMap[subPage] : 'div'

  return <Content />
}
